import React, {useEffect, useState} from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {Button, Card, CardBody, CardTitle, Col, Input, Label, Modal, Row, Table} from "reactstrap";

import Switch from "react-switch"
import {notification} from 'antd';


import ClipLoader from "react-spinners/ClipLoader";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
    getAllLogisticProducts,
    changeStatusAll,
    changeStatusStep2Cheked,
    deleteProduct,
    deleteCheckedProducts
} from "../../store/actions";

import ObjectColumns from "./ObjectColumnsEng";
import SweetAlert from "react-bootstrap-sweetalert";
import Preloader from "../../components/Preloader/Preloader";
import Error from "../../components/Error/Error";
import FeatherIcon from "feather-icons-react";
import FilterComponent from "./FilterComponent";


const modalWarning = type => {
    notification[type]({
        message: 'შეცდომა',
        description: 'მონიშნეთ გრაფები',
    });
};
const Waiting = props => {
    const dispatch = useDispatch();


    const isLoading = useSelector((state) => state.products.isLoading);
    const error = useSelector((state) => state.products.error);
    const products = useSelector((state) => state.products.products);


    const [data, setData] = useState([])
    const [country, setCountry] = useState(1)
    const [creater, setCreater] = useState('admin')
    const [skip, setSkip] = useState(0)
    const [limit, setLimit] = useState(1000)

    const [selectProducts, setSelectProducts] = useState([])

    useEffect(() => {

        const filters = {
            skip: skip.toString(),
            limit: limit.toString(),
            country: props.auth.admin.country || 1,
            status: 'waiting',
            creater: creater,
            branch:'all',
        };

        const queryParams = new URLSearchParams(filters).toString();
        dispatch(getAllLogisticProducts(queryParams))
    }, [props.auth.admin.country])

    const onSelectAll = (isSelected) => {
        if (isSelected) {
            props.products.products.map((item) => {
                setSelectProducts(prevArray =>
                    [...prevArray, item._id]
                )
            })
        } else {
            setSelectProducts([])
        }
    }

    function onRowSelect(row, isSelected) {
        if (isSelected) {
            setSelectProducts(prevArray =>
                [...prevArray, row._id]
            )
        } else {
            setSelectProducts(selectProducts.filter(item => item !== row._id))
        }
    }

    useEffect(()=>{
        setData(products)
    },[products])
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="List" breadcrumbItem="Warehouse"/>
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <div className="button-items">
                                        <Link to={`/addWarehouse`} className="btn btn-primary w-xs waves-effect waves-light"><FeatherIcon icon="edit" className="icon-xs icon me-2 text-pending" />
                                        Add
                                        </Link>
                                    </div>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <FilterComponent
                        skip={skip}
                        limit={limit}
                        country={country}
                    />
                    <Row>
                        <Col lg={12}>
                            {
                                isLoading ? (
                                    <Preloader/>
                                ) : error ? (
                                    <Error/>
                                ) : (
                                    <Row>
                                        <ObjectColumns
                                            onRowSelect={onRowSelect}
                                            onSelectAll={onSelectAll}
                                            logisticProducts={data}
                                        />
                                    </Row>
                                )
                            }

                        </Col>
                    </Row>
                </div>
            </div>


        </React.Fragment>

    )
}


const mapStateToProps = state => {
    const {
        auth,
        products,
        logistic
    } = state
    return {
        auth,
        products,
        logistic
    }
};
export default withRouter(connect(mapStateToProps)(Waiting));
